export const mediaFieldTypes = {
    image: 'Image',
    text: 'Text',
    video: 'Video',
};

export const maxMediaFieldSizes = {
    [mediaFieldTypes.image]: 20 * 1024 * 1024, // 20MB
    [mediaFieldTypes.video]: 25 * 1024 * 1024, // 25MB
};